import { AlertTriangle } from "react-feather"
import NavHeader from "../pages/application/components/NavHeader"

const RedirectPage = () => {
  return (
    <div>
      <NavHeader/>
      <div className="col-3 d-flex flex-column justify-content-center align-items-center mx-auto vh-100">
        <AlertTriangle size={100}/>
        <label className="text-center font-24 font-weight-semibold">The <i>Acceptance and Application Portals</i> are now together!</label>
        <label className="text-center font-16">You can now access the <b>Acceptance portal</b> here: <br/> ⬇ </label>
        <button className="btn btn-primary" onClick={() => window.location.href = "https://applications.sduportal.ng/apply/login"}>Go to Application</button>
      </div>
    </div>
  )
}

export default RedirectPage
